import React, { Component } from "react";
import { addDays, format, sub } from "date-fns";

import { subDirectory } from "../../../config.json";
import { BlockBookingTimeSlot, getAvailableBoatList, getTimeSlot, getBoatHouse, OtherServiceListData, getBoatType, getGstData, savePinTransation, savePinTransation1, bookingBeforeTransaction, getBoatHouseTiming ,getDefaultPaymentType} from "../../../services/boatListService";
import { getLocalStorageValues, removeCookieData } from "../../../services/boat";
import { setLocalStorevalue } from "../../../services/authService";
import paymentGatwayURI from "../../../config.json";
import CryptoJS from 'crypto-js';

export const DataContext = React.createContext();
export class Dataprovider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentloading: false,
      boatdata: [],
      boatType: [],
      startDate: new Date(),
      selectedBoatHouseId: "",
      selectedBoatHouseName: "",
      selectedBoatClassId: "",
      selectedBoatClassName: "",
      selectedBoatTypeId: "",
      selectedBoatTypeName: "",
      TaxAmount: 0,
      TotalAmount: 0,
      BoatTaxAmount: 0,
      BoatTotalAmount: 0,
      BoatAmount: 0,
      ServiceTotalAmount: 0,
      ServiceTaxAmount: 0,
      RowerCharge: 0,
      DepositeAmount: 0,
      OtherServicesList: [],
      EntranceList: [],
      ParkingList: [],
      EntranceCart: [],
      OtherserviceCart: [],
      boatAvailableList: [],
      boatCart: [],
      ExpressboatCart: [],
      ticketCart: [],
      BoatName: "Boating",
      isAmountInfo: false,
      boatClosed: false,
      MinDate: new Date(),
      isUser: false,
      isBoatCardListLoading: true,
      isOtherCardListLoading: true,
      isOtherServiceAvailable: false,
      isBoatingListAvailable: false,
      isBoatType: true,
      isUserInfo: false,
      tabindex: 0,
      noFacility: false,
      cartadded: false,
      isOtherFacility: false,
      isParking: false,
      isEntrance:false,
      NormalBoatTime: [],
      TicketTime: [],
      ExpressBoatTime: [],
      isModalVisible: false,
      TicketBlockedData: [],
      TicketCanceledData: [],
      selectedid: [],
      type: "",
      // premiumstatus: [],
      isTimeLoading: false,
      boatingTypeValue:"Y",
      checkType:false
    };
  }

  encryptedValuesFun (value)  {
	  const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), "1d207344b9238202821030788db04eae6526857bf49bf7620303e33756503131").toString();
	 
    if (encryptedValue) {
      return encryptedValue.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); // Base64 URL-safe encoding
    }
	}
//   decryptedValuesFun = (formElement) => {
//     console.log("formElement", formElement)
//     if (!formElement || !(formElement instanceof HTMLFormElement)) {
//         return null;
//     }
    
//     let decryptedFormData = {};
//     for (const input of formElement.elements) {
//         if (input.name && input.value) {
//             const decryptedValue = CryptoJS.AES.decrypt(input.value.replace(/-/g, '+').replace(/_/g, '/'), "1d207344b9238202821030788db04eae6526857bf49bf7620303e33756503131").toString(CryptoJS.enc.Utf8);
//             const cleanDecryptedValue = decryptedValue.replace(/^"(.*)"$/, '$1');
//             decryptedFormData[input.name] = cleanDecryptedValue;
//         }
//     }
//     return decryptedFormData;
// };


  componentDidMount = () => {
    console.log(this.props, "context Props");

  };
  updateSelectedBoatHouseData = async (selectedBoatHouseId, selectedBoatHouseName, startDate,boatingType) => {
    await this.setState({
      selectedBoatHouseId: selectedBoatHouseId,
      selectedBoatHouseName: selectedBoatHouseName,
      startDate: new Date(startDate),
      boatingTypeValue:boatingType,

    });
  };
  setOpenNotification = (isOpen) => {
    this.setState({ openNotification: isOpen });
  };
  clearCartData = async () => {
    await this.setState({ blockedData: [], TicketBlockedData: [], TicketCanceledData: [], selectedid: [], type: "", cartadded: false, boatCart: [], ticketCart: [], ExpressboatCart: [], EntranceCart: [], OtherserviceCart: [], BoatAmount: 0, TaxAmount: 0, TotalAmount: 0, DepositeAmount: 0, BoatTotalAmount: 0, BoatTaxAmount: 0, ServiceTotalAmount: 0, ServiceTaxAmount: 0, RowerCharge: 0 });
  };
  showAmountInfo = async () => {
    await this.setState((prevState) => ({
      isAmountInfo: !prevState.isAmountInfo,
    }));
  };
  showUserInfo = async () => {
    await this.setState((prevState) => ({
      isUserInfo: !prevState.isUserInfo,
    }));
  };

    
 

  //to get opening and closeing time of boat house and disable min date based on closed time
  getBoatHouseTimingData = async (boathouseid) => {
    let data = {
      BoatHouseId: boathouseid,
    };
    const res = await getBoatHouseTiming(data);
    let boatopenTime = res.data.Response[0].BookingFrom;
    let boatcloseTime = res.data.Response[0].BookingTo;
    let ClosingBeforeTime = res.data.Response[0].ClosingBeforeTime;
    // let todayTime = format(new Date(), "HH:mm:ss");
    let todayDate = format(new Date(), "MM/dd/yyyy");
    let BookingStart = new Date(todayDate + " " + boatopenTime);
    let BookingEnd = new Date(todayDate + " " + boatcloseTime);
    await this.setState({ BookingStart, BookingEnd });
    let closetime = ClosingBeforeTime.split(`:`);
    // subtract closing time with closing before time
    let closeDateTime = sub(new Date(todayDate + " " + boatcloseTime), { hours: closetime[0], minutes: closetime[1], seconds: closetime[2] });
    if (closeDateTime < new Date()) {
      let mindate = addDays(new Date(), 1);
      await this.setState({ boatClosed: true, MinDate: mindate });
      if (new Date(format(this.state.MinDate, "MM/dd/yyyy") + " " + "00:00:00") > new Date(format(this.state.startDate, "MM/dd/yyyy") + " " + "00:00:00")) {
        await this.setState({ loading: false, startDate: mindate });
      }
    } else {
      await this.setState({ boatClosed: false, MinDate: new Date() });
    }
  };
  //geting gst persentage
  getGst = async () => {
    //boat gst
    let data = {
      ServiceId: "1",
      ValidDate: format(new Date(), "dd/MM/yyyy"),
    };
    const res = await getGstData(data);
    if (res.data.StatusCode && res.data.Response?.[0]) {
      //converting gst name to gst persentage
      let gstname = res.data.Response[0].TaxName;
      let gstPercentage = 0;
      gstname.split(",").map((gst) => {
        let index = gst.indexOf("-");
        let percent = gst.substr(index + 1);
        gstPercentage += parseFloat(percent);
      });
      let gsname = gstname.replace(/(^\,)|,/g, "#");
      console.log(gsname.replaceAll(" ", ""), "gsname");
      await this.setState({ gstPercentage: gstPercentage, gstName: gsname.replaceAll(" ", "") });
    }
    //otherservices gst
    let data1 = {
      ServiceId: "2",
      ValidDate: format(new Date(), "dd/MM/yyyy"),
    };
    const res1 = await getGstData(data1);
    if (res1.data.StatusCode && res1.data.Response?.[0]) {
      //converting gst name to gst persentage
      let otsgstname = res1.data.Response[0].TaxName;
      let otsgstPercentage = 0;
      otsgstname.split(",").map((gst) => {
        let index = gst.indexOf("-");
        let percent = gst.substr(index + 1);
        otsgstPercentage += parseFloat(percent);
      });
      let osname = otsgstname.replace(/(^\,)|,/g, "#");
      console.log(osname.replaceAll(" ", ""), "gsname");
      await this.setState({ otsgstPercentage: otsgstPercentage, otsgstName: osname.replaceAll(" ", "") });
    }
  };

  getboatHouse = async () => {
    
    const res = await getBoatHouse();
    if (res.data.StatusCode === 1) {
      return this.setState({ boatHouse: res.data.Response });
    } else {
      return this.setState({ boatHouse: [] });
    }
  };

  

  getBoatTypeList = async (boathouseid) => {
    let data = {
      BoatHouseId: boathouseid,
    };
    const res = await getBoatType(data);
    console.log(res);
    if (res.data.StatusCode === 1) {
      if (res.data.Response.length > 0) {
        res.data.Response.unshift({ BoatTypeId: "All", BoatType: "All" });
        return this.setState({ boatType: res.data.Response, selectedBoatTypeId: "All", selectedBoatTypeName: "All" });
      }
    } else {
      return this.setState({ boatType: [], selectedBoatTypeId: null, selectedBoatTypeName: null });
    }
  };

  handleBoatHouseChange = async (e) => {
    await this.setState({
      selectedBoatHouseId: e.BoatHouseId,
      selectedBoatHouseName: e.BoatHouseName,
      tabindex: 0,
      isBoatType: false,
      noFacility: false,
      isOtherFacility: false,
      isParking: false,
      isEntrance:false,
      BoatName: "Boating",
      boatingTypeValue:e.BoatingType,
      checkType:false
    });
    await this.getBoatTypeList(e.BoatHouseId);
    await this.getBoatHouseTimingData(e.BoatHouseId);
    await this.getAvailableBoat();
    await this.setState({ isBoatType: true });
    await this.clearCartData(); //
    this.forceUpdate();
  };

  handleDateChange = async (date) => {
    await this.setState({
      startDate: date,
    });
    console.log(date);
    await this.getAvailableBoat();
    await this.clearCartData();
  };

  boatTypeChange = async (e) => {
    await this.setState({ selectedBoatTypeId: e.BoatTypeId, selectedBoatTypeName: e.BoatType });
    await this.getAvailableBoat();
  };

  getTimeSlot = async (slot, boat) => {
    console.log("858", boat);
    let data = {
      QueryType: "GetAvailableBoatSlot",
      BoatHouseId: boat.BoatHouseId,
      BoatTypeId: boat.BoatTypeId,
      CheckInDate: this.state.startDate,
      BoatSeaterId: boat.BoatSeaterId,
      SlotType: slot,
    };
    console.log("data", data);
    const res = await getTimeSlot(data);
    console.log(res, "gettime");

    if (slot === "I") {
      if (res.data.StatusCode == 1 && res.data?.Response?.length > 0) {
        if (this.state.ticketCart?.length > 0) {
          res.data.Response.map((Islot, index) => {
            this.state.ticketCart.map((tboat) => {
              console.log(tboat, Islot, tboat.Timeslot.SlotId, Islot.SlotId);
              // console.log(tboat.Timeslot.SlotId === Islot.SlotId, tboat.TimeSlot.SlotId,Islot.SlotId, tboat, Islot)
              if (tboat.Timeslot.SlotId == Islot.SlotId) {
                return (Islot.AvailableTripCount = Islot.AvailableTripCount - tboat.count);
              }
            });
          });
        }
        console.log(res.data.Response);
        this.setState({ TicketTime: res.data.Response });
      } else {
        this.setState({ TicketTime: [] });
      }
    } else if (slot === "N") {
      if (res.data.StatusCode == 1 && res.data.Response.length > 0) {
        if (this.state.boatCart?.length > 0) {
          res.data.Response.map((Islot, index) => {
            this.state.boatCart.map((tboat) => {
              console.log(tboat, Islot, tboat.Timeslot.SlotId, Islot.SlotId);
              // console.log(tboat.Timeslot.SlotId === Islot.SlotId, tboat.TimeSlot.SlotId,Islot.SlotId, tboat, Islot)
              if (tboat.Timeslot.SlotId == Islot.SlotId) {
                return (Islot.AvailableTripCount = Islot.AvailableTripCount - tboat.count);
              }
            });
          });
        }
        this.setState({ NormalBoatTime: res.data.Response });
      } else {
        this.setState({ NormalBoatTime: [] });
      }
    } else if (slot === "P") {
      if (res.data.StatusCode == 1 && res.data.Response.length > 0) {
        if (this.state.ExpressboatCart?.length > 0) {
          res.data.Response.map((Islot, index) => {
            this.state.ExpressboatCart.map((tboat) => {
              console.log(tboat, Islot, tboat.Timeslot.SlotId, Islot.SlotId);
              // console.log(tboat.Timeslot.SlotId === Islot.SlotId, tboat.TimeSlot.SlotId,Islot.SlotId, tboat, Islot)
              if (tboat.Timeslot.SlotId == Islot.SlotId) {
                return (Islot.AvailableTripCount = Islot.AvailableTripCount - tboat.count);
              }
            });
          });
        }
        this.setState({ ExpressBoatTime: res.data.Response });
      } else {
        this.setState({ ExpressBoatTime: [] });
      }
    }
    console.log(res);
  };
  getAvailableBoat = async () => {
    await this.setState({ isBoatCardListLoading: true, isBoatingListAvailable: false });
    const { selectedBoatHouseId, selectedBoatTypeId, startDate } = this.state;
    let data = {};
    if (selectedBoatTypeId == "All") {
      data = {
        QueryType: "BoatAvailable",
        BoatHouseId: selectedBoatHouseId,
        BookingDate: startDate,
      };
    } else {
      data = {
        QueryType: "BoatAvailable",
        BoatHouseId: selectedBoatHouseId,
        BoatType: selectedBoatTypeId,
        BookingDate: startDate,
      };
    }
    const res = await getAvailableBoatList(data);
    console.log(res, data);
    if (res.data.StatusCode == 1) {
      if (res.data.Response.length > 0) {
        res.data.Response.map((boat) => {
          boat["boatid"] = `${boat.BoatSeaterId}${boat.BoatTypeId}${boat.BoatHouseId}`;
          boat["count"] = 1;
          if (boat.DepositType === "P") {
            boat["NBdepositeCharge"] = parseFloat((parseFloat(boat.BoatTotalCharge || 0) * parseFloat(boat.Deposit || 0)) / 100).toFixed(2);
            boat["ECdepositeCharge"] = parseFloat((parseFloat(boat.ECBoatTotalCharge || 0) * parseFloat(boat.Deposit || 0)) / 100).toFixed(2);
            boat["NTdepositeCharge"] = parseFloat((parseFloat(boat.NTBoatTotalCharge || 0) * parseFloat(boat.Deposit || 0)) / 100).toFixed(2);
          } else {
            boat["NBdepositeCharge"] = boat.Deposit;
            boat["ECdepositeCharge"] = boat.Deposit;
            boat["NTdepositeCharge"] = boat.Deposit;
          }
        });
      }
      console.log(res.data.Response);
      await this.setState({ boatAvailableList: res.data.Response, isBoatCardListLoading: false, isBoatingListAvailable: true });
    } else {
      await this.setState({ boatAvailableList: [], isBoatCardListLoading: false, isBoatingListAvailable: false });
    }
    await this.getOtherServices(this.state.selectedBoatHouseId);
    this.forceUpdate();
  };
  getOtherServices = async (boathouseid) => {
    let data = {
      BoatHouseId: boathouseid,
    };
    let Parking = [],
      Entrance = [],
      OtherServicesList = [];
    const res = await OtherServiceListData(data);
    if (res.data.StatusCode == 1) {
      if (res.data.Response.length > 0) {
        
        await res.data.Response?.map((service) => {
          service["count"] = 1;
          if (service.CategoryName.includes("Parking")) {
            Parking.push(service);
          } else if (service.CategoryName.includes("Entrance")) {
            Entrance.push(service);
          } else {
            OtherServicesList.push(service);
          }
        });
        console.log("getOtherServices")
        await this.setState({
          OtherServicesList: OtherServicesList,
          ParkingList: Parking,
          EntranceList: Entrance,
          isOtherCardListLoading: false,
          isOtherServiceAvailable: true,
          // noFacility: (OtherServicesList?.length==0 && Parking?.length==0 && Entrance?.length > 0 ? true : false)
        });
      }
    } else {
     
      this.setState({
        OtherServicesList: [],
        ParkingList: [],
        EntranceList: [],
        isOtherCardListLoading: false,
        noFacility: true,
        isOtherServiceAvailable: false,
      });
    }
  };
  AddOtherServicesCart = async (service) => {
    const { OtherserviceCart } = this.state;
    await this.setState({
      OtherserviceCart: [...OtherserviceCart, service],
      cartadded: true,
    });
    await this.AddEnteranceCart();
    await this.amountCalulation();
  };
  AddIndividualEnteranceCart = async (service) => {
    const { EntranceCart } = this.state;
    await this.setState({
      EntranceCart: [...EntranceCart, service],
      cartadded: true,
    });
    await this.amountCalulation();
  };
  AddEnteranceCart = async () => {
    const { EntranceList } = this.state;
    if (this.state.boatCart?.length > 0 || this.state.ticketCart?.length > 0 || this.state.ExpressboatCart?.length > 0 || this.state.OtherserviceCart?.length > 0) {
      await this.setState({ EntranceCart:[...EntranceList], cartadded: true });
    }

    await this.amountCalulation();
  };

  incrementEntranceCart = async (serviceid) => {
    let tservicecart = this.state.EntranceCart;
    const selectedservicecart = tservicecart.find((service) => service.ServiceId === serviceid);
    const index = tservicecart.indexOf(selectedservicecart);
    const services = tservicecart[index];
    services.count = services.count + 1;
    await this.setState({ EntranceCart: tservicecart});
    await this.amountCalulation();
  };
  decrementEntranceCart = async (serviceid) => {
    let tservicecart = this.state.EntranceCart;
    const selectedservicecart = tservicecart.find((service) => service.ServiceId === serviceid);
    const index = tservicecart.indexOf(selectedservicecart);
    const services = tservicecart[index];
    if (services.ServiceName.includes("Adult")) {
      if (services.count > 1) {
        services.count = services.count - 1;
      }
    } else if (services.ServiceName.includes("Child")) {
      if (services.count > 0) {
        services.count = services.count - 1;
      }
    }
    await this.setState({ EntranceCart: tservicecart });
    await this.amountCalulation();
  };

  incrementOtherService = async (serviceid) => {
    let tservicecart = this.state.OtherserviceCart;
    const selectedservicecart = tservicecart.find((service) => service.ServiceId === serviceid);
    const index = tservicecart.indexOf(selectedservicecart);
    const services = tservicecart[index];
    services.count = services.count + 1;
    await this.setState({ OtherserviceCart: tservicecart });
    await this.amountCalulation();
  };
  decrementOtherService = async (serviceid) => {
    let tservicecart = this.state.OtherserviceCart;
    const selectedservicecart = tservicecart.find((service) => service.ServiceId === serviceid);
    const index = tservicecart.indexOf(selectedservicecart);
    const services = tservicecart[index];
    if (services.count > 1) {
      services.count = services.count - 1;
    } else {
      tservicecart.splice(index, 1);
    }
    await this.setState({ OtherserviceCart: tservicecart });
    await this.AddEnteranceCart();
    await this.amountCalulation();
  };
  RemoveExpressBoat = async (boat) => {
    const removeIndex = this.state.ExpressboatCart.findIndex((item) => item.boatslotid === boat.boatslotid);
    this.state.ExpressboatCart.splice(removeIndex, 1);
    await this.setState({ ExpressboatCart: this.state.ExpressboatCart });
    await this.SelectTimeSlot(boat, "P");
    await this.AddEnteranceCart();
    await this.amountCalulation();
  };
  RemoveTicket = async (boat) => {
    const removeIndex = this.state.ticketCart.findIndex((item) => item.boatslotid === boat.boatslotid);
    this.state.ticketCart.splice(removeIndex, 1);
    await this.setState({ ticketCart: this.state.ticketCart });
    await this.SelectTimeSlot(boat, "I");
    await this.AddEnteranceCart();
    await this.amountCalulation();
  };
  RemoveBoat = async (boat) => {
    const removeIndex = this.state.boatCart.findIndex((item) => item.boatslotid === boat.boatslotid);
    this.state.boatCart.splice(removeIndex, 1);
    await this.setState({ boatCart: this.state.boatCart });
    await this.SelectTimeSlot(boat, "N");
    await this.AddEnteranceCart();
    await this.amountCalulation();
  };
  RemoveEntrance = async (boat) => {
    const removeIndex = this.state.EntranceCart.findIndex((item) => item.ServiceId === boat.ServiceId);
    this.state.EntranceCart.splice(removeIndex, 1);
    await this.setState({ EntranceCart: this.state.EntranceCart });
    await this.amountCalulation();
  };
  RemoveOtherservice = async (boat) => {
    const removeIndex = this.state.OtherserviceCart.findIndex((item) => item.ServiceId === boat.ServiceId);
    this.state.OtherserviceCart.splice(removeIndex, 1);
    await this.setState({ OtherserviceCart: this.state.OtherserviceCart });
    await this.amountCalulation();
  };
  CheckLength = async () => {
    
    if (this.state.OtherServicesList?.length > 0 && this.state.boatCart?.length === 0 && this.state.ExpressboatCart?.length === 0 && this.state.ticketCart?.length === 0 && this.state.OtherserviceCart?.length === 0 && this.state.EntranceCart?.length === 0) {
      this.setState({ noFacility: false, isOtherFacility: false, isParking: false, isEntrance: false, tabindex: 0 });
    }
  };
  amountCalulation = async () => {
    let taxAmount = 0,
      totalAmount = 0,
      boatTaxAmount = 0,
      boatTotalAmount = 0,
      boatAmount = 0,
      serviceTaxAmount = 0,
      serviceTotalAmount = 0,
      depositeAmount = 0,
      rowerCharge = 0,
      otherservicecartdata = [...this.state.OtherserviceCart, ...this.state.EntranceCart];
    if (this.state.boatCart.length > 0) {
      await this.state.boatCart.map((boatc) => {
        boatTaxAmount += parseFloat(boatc.BoatTaxCharge || 0) * boatc.count;
        boatTotalAmount += parseFloat(boatc.BoatTotalCharge || 0) * boatc.count;
        boatAmount += parseFloat(boatc.BoatMinCharge || 0) * boatc.count;
        depositeAmount += parseFloat(boatc.NBdepositeCharge || 0) * boatc.count;
        rowerCharge += parseFloat(boatc.RowerMinCharge || 0) * boatc.count;
      });
    }
    if (this.state.ExpressboatCart.length > 0) {
      await this.state.ExpressboatCart.map((eboatc) => {
        boatTaxAmount += parseFloat(eboatc.ECBoatTaxCharge || 0) * eboatc.count;
        boatTotalAmount += parseFloat(eboatc.ECBoatTotalCharge || 0) * eboatc.count;
        boatAmount += parseFloat(eboatc.ECBoatMinCharge || 0) * eboatc.count;
        depositeAmount += parseFloat(eboatc.ECdepositeCharge || 0) * eboatc.count;
        rowerCharge += parseFloat(eboatc.ECRowerMinCharge || 0) * eboatc.count;
      });
    }

    if (this.state.ticketCart.length > 0) {
      await this.state.ticketCart.map((nboatc) => {
        boatTaxAmount += parseFloat(nboatc.NTBoatTaxCharge || 0) * nboatc.count;
        boatTotalAmount += parseFloat(nboatc.NTBoatTotalCharge || 0) * nboatc.count;
        boatAmount += parseFloat(nboatc.NTBoatMinCharge || 0) * nboatc.count;
        depositeAmount += parseFloat(nboatc.NTdepositeCharge || 0) * nboatc.count;
        rowerCharge += parseFloat(nboatc.NTRowerMinCharge || 0) * nboatc.count;
      });
    }
    if (otherservicecartdata?.length > 0) {
      await otherservicecartdata.map((service) => {
        serviceTaxAmount += parseFloat(service.ChargePerItemTax || 0) * service.count;
        serviceTotalAmount += parseFloat(service.ServiceTotalAmount || 0) * service.count;
      });
    }
    taxAmount = boatTaxAmount + serviceTaxAmount;
    totalAmount = boatTotalAmount + serviceTotalAmount + depositeAmount;
    console.log({ taxAmount, totalAmount, serviceTotalAmount, depositeAmount, boatAmount, rowerCharge });
    await this.setState({ RowerCharge: rowerCharge, TaxAmount: taxAmount, TotalAmount: totalAmount, BoatAmount: boatAmount, BoatTotalAmount: boatTotalAmount, BoatTaxAmount: boatTaxAmount, DepositeAmount: depositeAmount, ServiceTotalAmount: serviceTotalAmount, ServiceTaxAmount: serviceTaxAmount });
    this.forceUpdate();
    await this.CheckLength();
  };

  loginUsers = async (values) => {
    let UserId = await getLocalStorageValues("UserId");
    let MobileNo = await getLocalStorageValues("MobileNo");
    let EmailId = await getLocalStorageValues("EmailId");
    await this.setState({ MobileNo, EmailId, UserId, isUser: true });
  };
  // ! boat booking api call for  savepin,beforeTransaction,AfterTransaction
  checkloginData = async () => {
    console.log("check");
    await this.setState({
      UserId: await getLocalStorageValues("UserId"),
      MobileNo: await getLocalStorageValues("MobileNo"),
      EmailId: await getLocalStorageValues("EmailId"),
      loading: true,
    });
    if (this.state.boatCart.length === 0 && this.state.ExpressboatCart.length === 0 && this.state.ticketCart === 0 && this.state.OtherserviceCart.length === 0) {
      await this.setState({
        loading: false,
        variant: "info",
        openNotification: true,
        message: "Select Boat / Facility!!",
      });
    } else if (this.state.UserId === null || this.state.UserId === "") {
      //!tocheck user login or not
      this.setState({ loading: false, showLoginModal: true });
    }
  };
  // ! boat booking api call for  savepin,beforeTransaction,AfterTransaction

  ValidateEmail = (mail) => {
    var regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regexp.test(String(mail).toLowerCase())) {
      return true;
    }
    return false;
  };

  RemoveExpressBookingSlot = async (canceldata) => {
    console.log(canceldata);
    const { selectedBoatHouseId } = this.state;
    let Boatslotid = `${canceldata.BoatSeaterId}${canceldata.BoatTypeId}${selectedBoatHouseId}${canceldata.SlotId}${canceldata.BookingType}`;
    let ExpressBoatCart = this.state.ExpressboatCart;
    let EBoatSlot = this.state.ExpressBoatTime;
    const selectedboat = ExpressBoatCart.find((boat) => boat.boatslotid == Boatslotid);
    console.log(selectedboat, Boatslotid);
    const index = ExpressBoatCart.indexOf(selectedboat);
    const sboat = ExpressBoatCart[index];
    console.log(sboat);
    if (sboat.count > 1) {
      sboat.count = sboat.count - 1;
      console.log(sboat, this.state.ExpressBoatCart);
      await this.setState({ ExpressBoatTime: EBoatSlot, ExpressboatCart: ExpressBoatCart });
    } else {
      const removeIndex = this.state.ExpressboatCart.findIndex((item) => item.boatslotid == Boatslotid);
      this.state.ExpressboatCart.splice(removeIndex, 1);
      await this.setState({ ExpressBoatTime: EBoatSlot, ExpressboatCart: ExpressBoatCart });
    }
    await this.amountCalulation();
  };
  RemoveTicketBookingSlot = async (canceldata) => {
    console.log(canceldata);
    const { selectedBoatHouseId } = this.state;
    let Boatslotid = `${canceldata.BoatSeaterId}${canceldata.BoatTypeId}${selectedBoatHouseId}${canceldata.SlotId}${canceldata.BookingType}`;
    let TticketCart = this.state.ticketCart;
    let TTimeSlot = this.state.TicketTime;
    const selectedboat = TticketCart.find((boat) => boat.boatslotid == Boatslotid);
    console.log(selectedboat, Boatslotid);
    const index = TticketCart.indexOf(selectedboat);
    const sboat = TticketCart[index];
    console.log(sboat);
    if (sboat.count > 1) {
      sboat.count = sboat.count - 1;
      console.log(sboat, this.state.TticketCart);
      await this.setState({ TicketTime: TTimeSlot, ticketCart: TticketCart });
    } else {
      const removeIndex = this.state.ticketCart.findIndex((item) => item.boatslotid == Boatslotid);
      this.state.ticketCart.splice(removeIndex, 1);
      await this.setState({ TicketTime: TTimeSlot, ticketCart: TticketCart });
    }
    await this.amountCalulation();
  };
  RemoveBoatBookingSlot = async (canceldata) => {
    console.log(canceldata);
    const { selectedBoatHouseId } = this.state;
    let Boatslotid = `${canceldata.BoatSeaterId}${canceldata.BoatTypeId}${selectedBoatHouseId}${canceldata.SlotId}${canceldata.BookingType}`;
    let BoatCart = this.state.boatCart;
    let BoatSlot = this.state.NormalBoatTime;
    const selectedboat = BoatCart.find((boat) => boat.boatslotid == Boatslotid);
    console.log(selectedboat, Boatslotid, BoatCart, BoatSlot);
    const index = BoatCart.indexOf(selectedboat);
    const sboat = BoatCart[index];
    console.log(sboat);
    if (sboat.count > 1) {
      sboat.count = sboat.count - 1;
      console.log(sboat, this.state.BoatCart);
      await this.setState({ NormalBoatTime: BoatSlot, boatCart: BoatCart });
    } else {
      const removeIndex = this.state.boatCart.findIndex((item) => item.boatslotid == Boatslotid);
      this.state.boatCart.splice(removeIndex, 1);
      await this.setState({ NormalBoatTime: BoatSlot, boatCart: BoatCart });
    }
    await this.amountCalulation();
  };

  BlockBookingTime = async () => {
    const { boatCart, ticketCart, ExpressboatCart, selectedBoatHouseId, startDate, selectedBoatHouseName, selectedBoatClassName } = this.state;
    let boatTypeId = [],
      boatSeaterId = [],
      TripCountIds = [],
      SlotIds = [],
      BookingBlockId = [];
    let STNEboatdata = [...boatCart, ...ticketCart, ...ExpressboatCart];
    let bookingtype = [];
    // if (boatCart.length > 0) {
    //   bookingtype = "N";
    //   await this.setState({ selectedBoatClassId: "N", selectedBoatClassName: "Normal" });
    // } else if (ExpressboatCart.length > 0) {
    //   bookingtype = "P";
    //   await this.setState({ selectedBoatClassId: "P", selectedBoatClassName: "Express" });
    // } else if (ticketCart.length > 0) {
    //   bookingtype = "I";
    //   await this.setState({ selectedBoatClassId: "I", selectedBoatClassName: "Individual" });
    // }

    console.log(bookingtype, "bookingtype");
    STNEboatdata.forEach((boat) => {
      for (var i = 0; i < boat.count; i++) {
        let blockedid = 0;
        if (this.state.TicketBlockedData.length > 0) {
          const removeIndex = this.state.TicketBlockedData.findIndex((item) => `${item.BoatSeaterId}${item.BoatTypeId}${selectedBoatHouseId}${item.SlotId}${item.BookingType}` == boat.boatslotid);
          console.log(removeIndex, "removeIndex");
          if (removeIndex >= 0) {
            blockedid = this.state.TicketBlockedData[removeIndex].BlockedId;
            console.log(blockedid, "blockedid");
            this.state.TicketBlockedData.splice(removeIndex, 1);
          }
        }
        console.log(blockedid, "bookingblockid");
        boatTypeId.push(boat.BoatTypeId);
        boatSeaterId.push(boat.BoatSeaterId);
        TripCountIds.push(1);
        BookingBlockId.push(blockedid);
        bookingtype.push(boat.slottype);

        SlotIds.push(boat.Timeslot.SlotId);
      }
    });
    let data = {
      BookingDate: format(new Date(startDate), "dd/MM/yyyy"),
      // BookingType: bookingtype,
      BookingType: bookingtype,
      BoatHouseId: selectedBoatHouseId,
      BookingUser: await getLocalStorageValues("UserId"),
      BoatTypeIds: boatTypeId,
      SlotIds: SlotIds,
      BoatSeaterIds: boatSeaterId,
      TripCountIds: TripCountIds,
      BookingBlockId: BookingBlockId,
    };
    console.log(data, "blockdata");
    let blockedData = [];
    let cancelledData = [];
    const res = await BlockBookingTimeSlot(data);
    console.log(res);
    // 0: "Success ~ BlockedId: 1472, SlotId: 282, TimeSlot: 14:00:00 to 15:30:00, BookingType:N,
    // BoatTypeId:201, BoatType:5 - Seater, BoatSeaterId:171, BoatSeater:Pedal Boat"
    if (res.data.StatusCode == 1 && res.data.Response) {
      let EmptyResponse = false;
      res.data.Response.map((data) => {
        console.log(data, "reee");
        if (data.includes("Not Available")) {
          let value = data.split("~");
          let value2 = value[1];
          console.log(value2);
          let value3 = value2.replace(", Selected Slot is Not Available", "");
          console.log(value3);
          let cancellArray = value3.split(",");
          let cancellData = {
            SlotId: cancellArray[0].split(":")[1].trim(),
            TimeSlot: cancellArray[1].split("TimeSlot:")[1].trim(),
            BookingType: cancellArray[2].split(":")[1].trim(),
            BoatTypeId: cancellArray[3].split(":")[1].trim(),
            BoatType: cancellArray[4].split(":")[1].trim(),
            BoatSeaterId: cancellArray[5].split(":")[1].trim(),
            BoatSeater: cancellArray[6].split(":")[1].trim(),
          };
          cancelledData.push(cancellData);
          console.log(cancellData);
        } else if (data.includes("BlockedId")) {
          let value = data.split("~");
          let value2 = value[1];
          let blockArray = value2.split(",");
          let blockData = {
            BlockedId: blockArray[0].split(":")[1].trim(),
            SlotId: blockArray[1].split(":")[1].trim(),
            TimeSlot: blockArray[2].split("TimeSlot:")[1].trim(),
            BookingType: blockArray[3].split(":")[1].trim(),
            BoatTypeId: blockArray[4].split(":")[1].trim(),
            BoatType: blockArray[5].split(":")[1].trim(),
            BoatSeaterId: blockArray[6].split(":")[1].trim(),
            BoatSeater: blockArray[7].split(":")[1].trim(),
          };
          blockedData.push(blockData);
          console.log(blockData);
          this.setState({ BookingBlockedId: blockData.BlockedId, BookingTimeSlotId: blockData.SlotId, blockedData: blockedData });
        } else {
          // If Excepted response is not come
          return (EmptyResponse = true);
        }
      });
      await this.setState({
        TicketBlockedData: blockedData,
        TicketCanceledData: cancelledData,
      });
      if (EmptyResponse === true) {
        this.setState({ isModalVisible: true, alertmessage: "Something Went Wrong" });
        return false;
      }
      if (cancelledData.length > 0) {
        console.log(cancelledData);
        // alertmessage should be in slotcontent.
        await this.setState({
          isModalVisible: true,
          alertmessage: "slotcontent",
        });
        // if (bookingtype === "P") {
        cancelledData.map(async (canceldata) => {
          console.log("counts", canceldata);
          if (canceldata.BookingType === "P") {
            await this.RemoveExpressBookingSlot(canceldata);
          } else if (canceldata.BookingType === "N") {
            await this.RemoveBoatBookingSlot(canceldata);
          } else if (canceldata.BookingType === "I") {
            await this.RemoveTicketBookingSlot(canceldata);
          }
        });
        // }
        // else if (bookingtype === "N") {

        // cancelledData.map(async (canceldata) => {
        //   console.log("counts", canceldata);
        //   if(canceldata.BookingType === "N"){
        //     await this.RemoveBoatBookingSlot(canceldata);
        //   }

        // });
        // } else if (bookingtype === "I") {
        // cancelledData.map(async (canceldata) => {
        //   console.log("counts", canceldata);
        //   if(canceldata.BookingType === "I"){
        //   await this.RemoveTicketBookingSlot(canceldata);
        //   }
        // });
        // }
        return false;
      } else {
        // All Slots blocked successfully

        return true;
      }
    } else {
      return false;
    }
    return false;
  };

  boatBooking = async () => {
    const { boatCart, ticketCart, ExpressboatCart, boatAvailableList, OtherserviceCart, EntranceCart, selectedBoatHouseId, startDate, selectedBoatHouseName, selectedBoatClassName } = this.state;
    let OtherServiceCartData = [...OtherserviceCart, ...EntranceCart];
    let STNEboatdata = [...boatCart, ...ticketCart, ...ExpressboatCart];
    let formData = this.formApi.getValues();
    let shortName = boatAvailableList?.[0]?.BHShortCode;
    if (Object.keys(formData).length != 0) {
      if (formData.Mobile == 0 || formData.Mobile == undefined) {
        formData.Mobile = "";
      }
      await setLocalStorevalue("EmailId", formData.EmailId);
      await setLocalStorevalue("MobileNo", formData.MobileNo);
    }

    if (getLocalStorageValues("UserId")) {
      if (getLocalStorageValues("MobileNo")?.length >= 10 
      // && this.ValidateEmail(getLocalStorageValues("EmailId"))
    ) {
        await this.setState({
          UserId: await getLocalStorageValues("UserId"),
          MobileNo: await getLocalStorageValues("MobileNo"),
          EmailId: await getLocalStorageValues("EmailId"),
          loading: true,
        });
      } else {
        if (getLocalStorageValues("MobileNo")?.length < 10) {
          setLocalStorevalue("MobileNo", "");
        }
        if (!this.ValidateEmail(getLocalStorageValues("EmailId"))) {
          await setLocalStorevalue("EmailId", "");
        }
        return await this.setState({
          loading: false,
          variant: "info",
          openNotification: true,
          message: " Enter User Info",
          isUserInfo: true,
        });
      }
    }
    if (STNEboatdata.length === 0 && OtherServiceCartData.length === 0) {
      await this.setState({
        loading: false,
        variant: "info",
        openNotification: true,
        message: "Select Boat / Other Facilities!!",
      });
    } else if (this.state.UserId === null || this.state.UserId === "") {
      //!tocheck user login or not
      this.setState({ loading: false, showLoginModal: true });
    } else if (
      // !getLocalStorageValues("EmailId") 
      // || 
      !getLocalStorageValues("MobileNo")
    ) {
      await this.setState({
        loading: false,
        variant: "info",
        openNotification: true,
        message: " Enter User Info",
        isUserInfo: true,
      });
    } else if (this.state.UserId !== null 
      // && getLocalStorageValues("EmailId") 
      && getLocalStorageValues("MobileNo")
    ) {
      //!To get bookingpin for booking before transaction
      this.setState({ isUserInfo: false, paymentloading: true });
      let blocktime = false;
      if (STNEboatdata.length > 0) {
        blocktime = await this.BlockBookingTime();
        console.log(blocktime, "blocktime");
      } else if (OtherServiceCartData.length > 0) {
        blocktime = true;
      }
      if (blocktime === false) {
        this.setState({ tabindex: 0 });
      }
      if (blocktime === true) {
        let pindata = {
          BookingDate: format(new Date(startDate), "dd/MM/yyyy"),
          BoatHouseId: selectedBoatHouseId,
          BoatHouseName: selectedBoatHouseName,
          UserId: this.state.UserId,
          MobileNo: this.state.MobileNo,
          BookingType: "U",
          BookingMedia: "PW",
        };
        const res = await savePinTransation(pindata);
        console.log(res);
        if (res.data.StatusCode === 1) {
          await this.setState({ BookingPin: res.data.Response });
        } else if (res.data.StatusCode === 0) {
          let pindata1 = {
            UserId: this.state.UserId,
            QueryType: "Pin",
            ServiceType: "BookPin",
            BookingDate: format(new Date(startDate), "dd/MM/yyyy"),
            BoatHouseId: selectedBoatHouseId,
            BookingId: "0",
          };
          const respin = await savePinTransation1(pindata1);
          console.log(respin);
          if (respin.data.Table.length != 0) {
            await this.setState({ BookingPin: respin.data.Table[0].BookingPin });
          }
        } else {
          return await this.setState({
            loading: false,
            variant: "info",
            openNotification: true,
            message: "Something Went Wrong",
          });
        }
        //!Boat Data Convertion
        let boatTypeId = [],
          boatSeaterId = [],
          InitBoatCharge = [],
          InitRowerCharge = [],
          BoatDeposit = [],
          BookingDuration = [],
          InitOfferAmount = [],
          InitNetAmount = [],
          BookingTimeSlotId = [],
          BookingBlockId = [],
          // TaxDetails = [],
          // TaxAmount = [],
          CGSTTaxAmount = [],
          SGSTTaxAmount = [],
          BoatPremiumStatus = [];

        STNEboatdata.forEach((boatcart) => {
          // Array.from({ length: boatcart.count }, (v, i) => {
          for (let count = 0; count < boatcart.count; count++) {
            console.log(boatcart, "cartboat");
            boatTypeId.push(boatcart.BoatTypeId);
            boatSeaterId.push(boatcart.BoatSeaterId);
            BookingDuration.push(boatcart.BoatMinTime);
            InitOfferAmount.push(0);
            BoatPremiumStatus.push(boatcart.slottype);
            if (boatcart.slottype == "N") {
              let NBInitNetAmount = parseFloat(parseFloat(boatcart.BoatTotalCharge || 0) + parseFloat(boatcart.NBdepositeCharge || 0)).toFixed(2);
              InitBoatCharge.push(boatcart.BoatMinCharge || 0);
              InitRowerCharge.push(boatcart.RowerMinCharge || 0);
              // InitNetAmount.push(boatcart.BoatTotalCharge || 0);
              InitNetAmount.push(NBInitNetAmount || 0);

              BoatDeposit.push(boatcart.NBdepositeCharge || 0);
              let Taxname = [];
              // TaxDetails.push(this.state.gstName);

              this.state.gstName.split("#").map((gst) => {
                // Taxname.push(`${gst}#${((boatcart.BoatTaxCharge || 0) * boatcart.count) / 2}`);
                Taxname.push(`${(boatcart.BoatTaxCharge || 0) / 2}`);
              });
              // TaxAmount.push(Taxname.join(`#`));
              CGSTTaxAmount.push(Taxname?.[0] || 0);
              SGSTTaxAmount.push(Taxname?.[1] || 0);
              console.log({ Taxname }, this.state.gstName, "TaxAmount");
            }
            if (boatcart.slottype == "P") {
              let ECInitNetAmount = parseFloat(parseFloat(boatcart.ECBoatTotalCharge || 0) + parseFloat(boatcart.ECdepositeCharge || 0)).toFixed(2);

              InitBoatCharge.push(boatcart.ECBoatMinCharge || 0);
              InitRowerCharge.push(boatcart.ECRowerMinCharge || 0);
              // InitNetAmount.push(boatcart.ECBoatTotalCharge || 0);
              InitNetAmount.push(ECInitNetAmount || 0);

              BoatDeposit.push(boatcart.ECdepositeCharge || 0);
              let Taxname = [];
              // TaxDetails.push(this.state.gstName);
              this.state.gstName.split("#").map((gst) => {
                Taxname.push(`${(boatcart.ECBoatTaxCharge || 0) / 2}`);
              });
              // TaxAmount.push(Taxname.join(`#`));
              CGSTTaxAmount.push(Taxname?.[0] || 0);
              SGSTTaxAmount.push(Taxname?.[1] || 0);
              console.log({ Taxname }, this.state.gstName, "TaxAmount");
            }
            if (boatcart.slottype == "I") {
              let NTInitNetAmount = parseFloat(parseFloat(boatcart.NTBoatTotalCharge || 0) + parseFloat(boatcart.NTdepositeCharge || 0)).toFixed(2);

              InitBoatCharge.push(boatcart.NTBoatMinCharge || 0);
              InitRowerCharge.push(boatcart.NTRowerMinCharge || 0);
              // InitNetAmount.push(boatcart.NTBoatTotalCharge || 0);
              InitNetAmount.push(NTInitNetAmount || 0);

              BoatDeposit.push(boatcart.NTdepositeCharge || 0);
              let Taxname = [];
              // TaxDetails.push(this.state.gstName);
              this.state.gstName.split("#").map((gst) => {
                Taxname.push(`${(boatcart.NTBoatTaxCharge || 0) / 2}`);
              });
              // TaxAmount.push(Taxname.join(`#`));
              CGSTTaxAmount.push(Taxname?.[0] || 0);
              SGSTTaxAmount.push(Taxname?.[1] || 0);
              console.log({ Taxname }, this.state.gstName, "TaxAmount");
            }
          }
        });

        // let BoatPremiumStatus = this.state.premiumstatus;

        let BookingType = "B";
        if (STNEboatdata.length === 0 && OtherServiceCartData.length > 0) {
          BookingType = "I";
        }

        let PremiumStatus = "";
        if (BookingType == "B") {
          console.log(BoatPremiumStatus, "primiumstatus");
          // PremiumStatus = this.state.premiumstatus.every((val, i, arr) => val === arr[0]) === true ? this.state.premiumstatus[0] : "M";
          PremiumStatus = BoatPremiumStatus.every((val, i, arr) => val === arr[0]) === true ? BoatPremiumStatus[0] : "M";
        }

        if (this.state?.blockedData?.length > 0) {
          this.state.blockedData.forEach((blockdata) => {
            BookingBlockId.push(blockdata.BlockedId);
            BookingTimeSlotId.push(blockdata.SlotId);
          });
        }
        //!Other Service Data Convertion

        // var OthServiceStatus = "N";
        var OthServiceStatus = [];

        let OthServiceId = [],
          OthChargePerItem = [],
          OthNoOfItems = [],
          OthNetAmount = [],
          // OthTaxDetails = [],
          // OthTaxAmount = [],
          CGSTOthTaxAmount = [],
          SGSTOthTaxAmount = [];
        if (OtherServiceCartData.length > 0) {
          // OthServiceStatus = "Y";

          OtherServiceCartData.forEach((service) => {
            OthServiceStatus.push("Y");
            OthServiceId.push(service.ServiceId);
            OthChargePerItem.push(service.ChargePerItem);
            OthNoOfItems.push(service.count);
            OthNetAmount.push((service.ServiceTotalAmount || 0) * service.count);
            let serviceTaxname = [];
            // OthTaxDetails.push(this.state.otsgstName);
            this.state.otsgstName.split("#").map((gst) => {
              serviceTaxname.push(`${((service.ChargePerItemTax || 0) * service.count) / 2}`);
            });
            // OthTaxAmount.push(serviceTaxname.join(`#`));

            CGSTOthTaxAmount.push(serviceTaxname?.[0] || 0);
            SGSTOthTaxAmount.push(serviceTaxname?.[1] || 0);
            console.log({ serviceTaxname }, this.state.otsgstName, "otsTaxAmount");
          });
        }
        //  else {
        //   OthServiceStatus.push("N");
        // }
        // Array.from({length: 5}, (v, i) => i);

        //! generating dummy data based on maximum size of array length(By comparing BoatData and OtherServicesData)
        let maxLength = 0,
          remainingLength = 0;
        let dummyData = [];
        const boatcount = STNEboatdata.reduce((count, boat) => (count = count + boat.count), 0);
        console.log(boatcount, "allboatcount");
        if (boatcount > OtherServiceCartData.length) {
          //! if boatData is more than otherServices
          maxLength = STNEboatdata.length;
          remainingLength = boatcount - OtherServiceCartData.length;
          Array.from({ length: remainingLength }, (v, i) => dummyData.push(0));
          OthServiceId = [...OthServiceId, ...dummyData];
          OthChargePerItem = [...OthChargePerItem, ...dummyData];
          OthNoOfItems = [...OthNoOfItems, ...dummyData];
          OthNetAmount = [...OthNetAmount, ...dummyData];
          // OthTaxDetails = [],
          // OthTaxAmount = [],
          CGSTOthTaxAmount = [...CGSTOthTaxAmount, ...dummyData];
          SGSTOthTaxAmount = [...SGSTOthTaxAmount, ...dummyData];

          OthServiceStatus = [
            ...OthServiceStatus,
            ...dummyData.map((d) => {
              return "N";
            }),
          ];
        } else if (OtherServiceCartData.length > boatcount) {
          //! if otherService Data is more than boat
          maxLength = OtherServiceCartData.length;
          remainingLength = OtherServiceCartData.length - boatcount;
          Array.from({ length: remainingLength }, (v, i) => dummyData.push(0));
          boatTypeId = [...boatTypeId, ...dummyData];
          boatSeaterId = [...boatSeaterId, ...dummyData];
          InitBoatCharge = [...InitBoatCharge, ...dummyData];
          InitRowerCharge = [...InitRowerCharge, ...dummyData];
          BoatDeposit = [...BoatDeposit, ...dummyData];
          BookingDuration = [...BookingDuration, ...dummyData];
          InitOfferAmount = [...InitOfferAmount, ...dummyData];
          InitNetAmount = [...InitNetAmount, ...dummyData];
          BookingTimeSlotId = [...BookingTimeSlotId, ...dummyData];
          BookingBlockId = [...BookingBlockId, ...dummyData];
          CGSTTaxAmount = [...CGSTTaxAmount, ...dummyData];
          SGSTTaxAmount = [...SGSTTaxAmount, ...dummyData];
          BoatPremiumStatus = [...BoatPremiumStatus, ...dummyData];
        }
        
        let EmailIdValue = this.state.EmailId !="" && this.state.EmailId !=null && this.state.EmailId !=undefined ? this.state.EmailId : ""
        var bookingData = {
          BookingDate: format(new Date(startDate), "dd/MM/yyyy"),
          BookingPin: this.state.BookingPin,
          UserId: this.state.UserId,
          MobileNo: this.state.MobileNo,
          EmailId: EmailIdValue,
          PaymentMode: "Online",
          Amount: String(this.state.TotalAmount),
          BookingType: BookingType,
          BoatHouseId: this.state.selectedBoatHouseId, // selectedBoatHouseId
          BoatHouseName: selectedBoatHouseName,
          PremiumStatus: PremiumStatus,
          BoatPremiumStatus: BoatPremiumStatus,
          NoOfPass: 0,
          NoOfChild: 0,
          NoOfInfant: 0,
          BoatTypeId: boatTypeId,
          BoatSeaterId: boatSeaterId,
          BookingDuration: BookingDuration,
          InitBoatCharge: InitBoatCharge,
          InitRowerCharge: InitRowerCharge,
          BoatDeposit: BoatDeposit,
          InitOfferAmount: InitOfferAmount,
          InitNetAmount: InitNetAmount,
          BookingTimeSlotId: BookingTimeSlotId,
          BookingBlockId: BookingBlockId,
          CGSTTaxAmount: CGSTTaxAmount,
          SGSTTaxAmount: SGSTTaxAmount,
          OthServiceStatus: OthServiceStatus,
          OthServiceId: BookingType == "B" ? OthServiceId : [OthServiceId.join("~")],
          OthChargePerItem: BookingType == "B" ? OthChargePerItem : [OthChargePerItem.join("~")],
          OthNoOfItems: BookingType == "B" ? OthNoOfItems : [OthNoOfItems.join("~")],
          OthNetAmount: BookingType == "B" ? OthNetAmount : [OthNetAmount.join("~")],
          CGSTOthTaxAmount: BookingType == "B" ? CGSTOthTaxAmount : [CGSTOthTaxAmount.join("~")],
          SGSTOthTaxAmount: BookingType == "B" ? SGSTOthTaxAmount : [SGSTOthTaxAmount.join("~")],
          BRSBookingId: "0",
          BRSNewDate: "0",
          BRSCharge: "0",
          BRSCGST: "0",
          BRSSGST: "0",
          BRSRuleId: "0",
          BookingMedia: "PW",
          BFDInitBoatCharge: "0",
          BFDInitNetAmount: "0",
          BFDGST: "0",
          EntryType: "PB",
          ModuleType: "Boating",
          CollectedAmount: String(this.state.TotalAmount),
          BalanceAmount: "0",
          currency:"INR",
          billing_name:"",
          billing_address:"",
          billing_city:"",
          billing_state:"",
          billing_zip:"",
          billing_country:"India",
          delivery_name:"",
          delivery_address:format(new Date(new Date(startDate)), "dd/MM/yyyy"),
          delivery_city:BookingType,
          delivery_state:BookingType == "B" ? (OtherServiceCartData.length > 0 ? "IB" : "B") : BookingType,
          delivery_zip:"",
          delivery_country:"India",
          delivery_tel:"",
          merchant_param1:this.state.selectedBoatHouseId,
          merchant_param2:"",
          merchant_param3:getLocalStorageValues("UserId"),
          merchant_param4:this.state.selectedBoatHouseName,
          merchant_param5:"BoatPaymentHandler.html"


        };
        let bres = await bookingBeforeTransaction(bookingData);
        console.log(bres, bookingData, JSON.stringify(bookingData));
        if (bres.data.StatusCode === 1) {
          
          let bookindid = bres.data.Response;
          var matches = bookindid.replace(/[^\d.-]/g, "");
          removeCookieData("Time");
          let paymentData = {
            "QueryType" : "GetPaymentGatewayPublic",
                           "ServiceType" : "",
                           "BoatHouseId" : "",
                           "Input1" : "",
                           "Input2" : "",
                           "Input3" :"",
                           "Input4" : "",
                           "Input5" : ""
        }
          const resPaymentData = await getDefaultPaymentType(paymentData);
          console.log("resPaymentData",resPaymentData)
          if(resPaymentData?.data?.Table?.[0]?.["PaymentGateway"]?.toLowerCase() !="hdfc" && Object.keys(resPaymentData?.data).length > 0){
            this.props.history.push({
              pathname: `${subDirectory}/boatPaymentPage`,
              state: {
                BoatData: { ...this.state },
                bookingData: bookingData,
                PaymentType: "Booking",
                TotalAmount: this.state.TotalAmount,
                BoatHouseId: this.state.selectedBoatHouseId,
                BookingId: matches,
                BoatHouseName: this.state.selectedBoatHouseName,
                TripDate: new Date(startDate),
                BookingType: BookingType,
                shortName: shortName,
                UserId: getLocalStorageValues("UserId"),
                Mobile: getLocalStorageValues("MobileNo"),
                Email: EmailIdValue,
              },
            });
          }
          else{
              // const randomNum = Math.floor(Math.random() * 100);
              // const paddedRandomNum = randomNum.toString().padStart(2, '0');
              // const orderId = shortName + "-" + paddedRandomNum;
              const form = document.createElement('form');
              form.method = 'POST';
              form.action = `${paymentGatwayURI.paymentGatwayURI}/ccavRequestHandler`;
              form.style.display = 'none'; // Hide the form
          
              // Add input fields
              const data1 = {
                  "merchant_id" : "3401574",
                  "order_id" : matches,
                  "currency": "INR",
                  "amount": this.state.TotalAmount,
                  "redirect_url":"https://ttdc.in/hdfc-payment-gateway/ccavResponseHandler",
                  "cancel_url":"https://ttdc.in/hdfc-payment-gateway/ccavResponseHandler",
                  "language":"EN",
                  "billing_name":"",
                  "billing_address":"",
                  "billing_city":"",
                  "billing_state":"",
                  "billing_zip":"",
                  "billing_country":"India",
                  "billing_tel":getLocalStorageValues("MobileNo"),
                  "billing_email":EmailIdValue,  
                  "delivery_name":"",
                  "delivery_address":format(new Date(new Date(startDate)), "dd/MM/yyyy"),
                  "delivery_city":BookingType,
                  "delivery_state":BookingType == "B" ? (OtherServiceCartData.length > 0 ? "IB" : "B") : BookingType,
                  "delivery_zip":"",
                  "delivery_country":"India",
                  "delivery_tel":"",
                  "merchant_param1":this.state.selectedBoatHouseId,
                  "merchant_param2":"",
                  "merchant_param3":getLocalStorageValues("UserId"),
                  "merchant_param4":this.state.selectedBoatHouseName,
                  "merchant_param5":"BoatPaymentHandler.html",
                  "promo_code":"",
                  "customer_identifier":""
              };
          
              Object.keys(data1).forEach(key => {
                  const input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = key;
                  // input.value = data1[key];
                  input.value = this.encryptedValuesFun(data1[key])
                  form.appendChild(input);
              });
          
              document.body.appendChild(form);
              
              // Submit the form
              form.submit();
          
            
          }
          
        }
      }
    }
    await this.setState({ paymentloading: false, loading: false });
  };

  Boatclick = async (data) => {
    await this.setState({ BoatName: data });
    if (data === "Boating") {
      this.setState({ tabindex: 0, noFacility: true });
    } else if (data === "Parking") {
      this.setState({ tabindex: 1, noFacility: true });
    } else if (data === "Other Facilities") {
      if (this.state.ParkingList.length > 0) {
        this.setState({ tabindex: 2, noFacility: true });
      }
      else {
        this.setState({ tabindex: (this.state.boatingTypeValue == "Y" || (this.state.boatingTypeValue == "N" && this.state.ParkingList.length == 0)) ? 1 : 0, noFacility: true });
      }
    }
    else if(data === "Entrance"){
      if (this.state.ParkingList.length > 0 && this.state.OtherServicesList.length > 0) {
        this.setState({ tabindex: this.state.boatingTypeValue == "Y" ? 3 : 0, noFacility: true });
      }else if(this.state.ParkingList.length > 0 || this.state.OtherServicesList.length > 0){
        this.setState({ tabindex: this.state.boatingTypeValue == "Y" ? 2 : 0, noFacility: true });
      }
      else{
        this.setState({ tabindex: this.state.boatingTypeValue == "Y" ? 1 : 0, noFacility: true });

      }
    }
  };
  handleLoginClose = async () => {
    await this.setState({ showLoginModal: false, loading: true });
    await this.setState({ loading: false });
  };

  ContinueButton = async (data) => {
    if (this.state.OtherServicesList.length > 0 && this.state.ParkingList?.length > 0) {
   
      if (this.state.isParking === false && this.state.isOtherFacility === false && this.state.isEntrance === false) {
      
        this.setState({ BoatName: "Parking", tabindex:  1, noFacility: false, isParking: true });
      } else if (this.state.isParking === true && this.state.isOtherFacility === false && this.state.isEntrance === false) {
        
        this.setState({ BoatName: "Other Facilities", tabindex:  2, noFacility: this.state.boatingTypeValue == "Y" ? false : true, isParking: true, isOtherFacility: true });
      }else if (this.state.isParking === true && this.state.isOtherFacility === true && this.state.isEntrance === false) {
       
        this.setState({ BoatName: "Entrance", tabindex: this.state.boatingTypeValue == "Y" ? 3 : 2, noFacility: true, isParking: true, isOtherFacility: true , isEntrance : true });
      }
    } else if (this.state.OtherServicesList.length > 0 && this.state.ParkingList.length === 0) {
      
      if (this.state.isParking === false && this.state.isOtherFacility === false && this.state.isEntrance === false) {
        this.setState({ BoatName: "Other Facilities", tabindex: this.state.boatingTypeValue == "Y" ? 1 : 2, noFacility: this.state.EntranceList.length > 0 ? false : true, isOtherFacility: true });
      }else if(this.state.isParking === false && this.state.isOtherFacility === true && this.state.isEntrance === false){
        this.setState({ BoatName: "Entrance", tabindex:  2, noFacility: true, isOtherFacility: true,isEntrance:true });

      }
    } else if (this.state.ParkingList.length > 0 && this.state.OtherServicesList.length === 0) {
      if (this.state.isParking === false && this.state.isOtherFacility === false && this.state.isEntrance === false) {
        this.setState({ BoatName: "Parking", tabindex: this.state.boatingTypeValue == "Y" ? 1 : 2, noFacility: this.state.EntranceList.length > 0 ? false : true, isParking: true });
      }else if(this.state.isParking === true && this.state.isOtherFacility === false && this.state.isEntrance === false){
        this.setState({ BoatName: "Entrance", tabindex:  2, noFacility: true, isOtherFacility: false,isEntrance:true });

      }
    }else if(this.state.ParkingList.length === 0 && this.state.OtherServicesList.length === 0 && this.state.EntranceList.length > 0){
      this.setState({ BoatName: "Entrance", tabindex:  1, noFacility: true, isOtherFacility: false,isEntrance:true });
    }

    
   
  };

  removeboatdata = async (data, boat) => {
    console.log(data, boat);
    let BoatCart = this.state.boatCart;
    if (data.count > 1) {
      const selectedboat = BoatCart.find((boats) => boats.boatslotid === data.boatslotid);
      console.log(selectedboat);
      const index = BoatCart.indexOf(selectedboat);
      const sboat = BoatCart[index];
      sboat.count = sboat.count - 1;
      console.log(sboat, this.state.boatCart);
      await this.setState({ boatCart: BoatCart });
    } else {
      console.log("lese ");
      const removeIndex = this.state.boatCart.findIndex((item) => item.boatslotid === data.boatslotid);
      this.state.boatCart.splice(removeIndex, 1);
      await this.setState({ boatCart: BoatCart });
      await this.AddEnteranceCart();
    }
    await this.getTimeSlot("N", boat);
    await this.amountCalulation();
  };
  removeticketdata = async (data, boat) => {
    console.log(data, boat);
    let TticketCart = this.state.ticketCart;
    if (data.count > 1) {
      const selectedboat = TticketCart.find((boats) => boats.boatslotid === data.boatslotid);
      console.log(selectedboat);
      const index = TticketCart.indexOf(selectedboat);
      const sboat = TticketCart[index];
      sboat.count = sboat.count - 1;
      console.log(sboat, this.state.ticketCart);
      await this.setState({ ticketCart: TticketCart });
    } else {
      const removeIndex = this.state.ticketCart.findIndex((item) => item.boatslotid === data.boatslotid);
      this.state.ticketCart.splice(removeIndex, 1);
      await this.setState({ ticketCart: TticketCart });
      await this.AddEnteranceCart();
    }
    await this.getTimeSlot("I", boat);
    await this.amountCalulation();
  };
  removeExpressdata = async (data, boat) => {
    console.log(data, boat);
    let ExpressBoatCart = this.state.ExpressboatCart;
    if (data.count > 1) {
      const selectedboat = ExpressBoatCart.find((boats) => boats.boatslotid === data.boatslotid);
      console.log(selectedboat);
      const index = ExpressBoatCart.indexOf(selectedboat);
      const sboat = ExpressBoatCart[index];
      sboat.count = sboat.count - 1;
      console.log(sboat, this.state.ExpressBoatCart);
      await this.setState({ ExpressboatCart: ExpressBoatCart });
    } else {
      console.log("lese ");
      const removeIndex = this.state.ExpressboatCart.findIndex((item) => item.boatslotid === data.boatslotid);
      this.state.ExpressboatCart.splice(removeIndex, 1);
      await this.setState({ ExpressboatCart: ExpressBoatCart });
      await this.AddEnteranceCart();
    }
    await this.getTimeSlot("P", boat);
    await this.amountCalulation();
  };

  ExpressTimeSlotClick = async (data, boat, slottype) => {
    // let premiumstatus = [...this.state.premiumstatus];
    // premiumstatus.push(slottype);
    // await this.setState({ premiumstatus: premiumstatus });
    let ExpressBoatCart = this.state.ExpressboatCart;
    let boatdata = { ...boat };
    boatdata["boatslotid"] = `${boat.boatid}${data.SlotId}${slottype}`;
    boatdata["SlotType"] = "Express";
    boatdata["slottype"] = "P";

    const check = ExpressBoatCart.every((boats) => {
      return boats.boatslotid !== boatdata.boatslotid;
    });
    console.log(check, "check");
    if (data.AvailableTripCount >= 1) {
      if (check) {
        boatdata["Timeslot"] = data;
        ExpressBoatCart.push(boatdata);
        await this.setState({ ExpressboatCart: ExpressBoatCart });
        await this.AddEnteranceCart();
      } else {
        const selectedboat = ExpressBoatCart.find((boats) => boats.boatslotid === boatdata.boatslotid);
        const index = ExpressBoatCart.indexOf(selectedboat);
        const sboat = ExpressBoatCart[index];
        sboat.count = sboat.count + 1;
        console.log(sboat, this.state.ExpressBoatCart);
        await this.setState({ ExpressboatCart: ExpressBoatCart });
      }
    } else {
      await this.setState({
        loading: false,
        variant: "info",
        openNotification: true,
        message: "Today Booking limit exceed",
      });
    }
    await this.getTimeSlot("P", boat);
    await this.amountCalulation();
  };
  TicketTimeSlotClick = async (data, boat, slottype) => {
    // let premiumstatus = [...this.state.premiumstatus];
    // premiumstatus.push(slottype);
    // await this.setState({ premiumstatus: premiumstatus });
    let TticketCart = this.state.ticketCart;
    let boatdata = { ...boat };
    boatdata["boatslotid"] = `${boat.boatid}${data.SlotId}${slottype}`;
    boatdata["SlotType"] = "Normal";
    boatdata["slottype"] = "I";
    const check = TticketCart.every((boats) => {
      return boats.boatslotid !== boatdata.boatslotid;
    });
    console.log(check, "check");
    if (data.AvailableTripCount >= 1) {
      if (check) {
        boatdata["Timeslot"] = data;
        TticketCart.push(boatdata);
        console.log(TticketCart);
        await this.setState({ ticketCart: TticketCart });
        await this.AddEnteranceCart();
      } else {
        const selectedboat = TticketCart.find((boats) => boats.boatslotid === boatdata.boatslotid);
        const index = TticketCart.indexOf(selectedboat);
        const sboat = TticketCart[index];
        sboat.count = sboat.count + 1;
        console.log(sboat, this.state.ticketCart);
        await this.setState({ ticketCart: TticketCart });
      }
    } else {
      await this.setState({
        loading: false,
        variant: "info",
        openNotification: true,
        message: "Today Booking limit exceed",
      });
    }
    await this.getTimeSlot("I", boat);
    await this.amountCalulation();
  };
  NormalTimeSlotClick = async (data, boat, slottype) => {
    // let premiumstatus = [...this.state.premiumstatus];
    // premiumstatus.push(slottype);
    // await this.setState({ premiumstatus: premiumstatus });
    let BoatCart = this.state.boatCart;
    let boatdata = { ...boat };
    boatdata["boatslotid"] = `${boat.boatid}${data.SlotId}${slottype}`;
    boatdata["SlotType"] = "Normal";
    boatdata["slottype"] = "N";

    const check = BoatCart.every((boats) => {
      return boats.boatslotid !== boatdata.boatslotid;
    });
    if (data.AvailableTripCount >= 1) {
      if (check) {
        boatdata["Timeslot"] = data;
        BoatCart.push(boatdata);
        console.log(BoatCart);
        await this.setState({ boatCart: BoatCart });
        await this.AddEnteranceCart();
      } else {
        const selectedboat = BoatCart.find((boats) => boats.boatslotid === boatdata.boatslotid);
        const index = BoatCart.indexOf(selectedboat);
        const sboat = BoatCart[index];
        sboat.count = sboat.count + 1;
        console.log(sboat, this.state.boatCart);
        await this.setState({ boatCart: BoatCart });
      }
    } else {
      await this.setState({
        loading: false,
        variant: "info",
        openNotification: true,
        message: "Today Booking limit exceed",
      });
    }
    await this.getTimeSlot("N", boat);
    await this.amountCalulation();
  };

  handleOk = () => {
    this.setState({ isModalVisible: false });
  };
  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };
  setFormApi = (formApi) => {
    this.formApi = formApi;
  };
  SelectTimeSlot = async (boat, type,EntranceFeeCount,countCheck) => {
    await this.setState({ TicketTime: [], NormalBoatTime: [], ExpressBoatTime: [], selectedid: [boat], type: type, isTimeLoading: true });
    await this.getTimeSlot(type, boat);
    if (countCheck){
      const updatedEntranceList = this.state.EntranceList?.map(item => {
        const parsedCount = parseInt(EntranceFeeCount[item.ServiceName], 10);
        const newCount = isNaN(parsedCount) ? item.count : parsedCount;
      
        return {
          ...item,
          count: newCount
        };
      });
      await this.setState({EntranceList:updatedEntranceList,checkType:true });
    }
    this.setState({ isTimeLoading: false });
    console.log(this.state, "stateee");
  };
  HideTimeSlot = async (boat, type) => {
    let tboatcart = this.state.selectedid;
    const selectedboat = tboatcart.find((boattime) => boattime.boatid === boat.boatid);
    const index = tboatcart.indexOf(selectedboat);
    tboatcart.splice(index, 1);
    await this.setState({ selectedid: tboatcart, type: type });
  };
  render() {
    const state = this.state;
    const { showUserInfo, showAmountInfo, handleLoginClose, handleOk, handleCancel, setOpenNotification, setFormApi, SelectTimeSlot, HideTimeSlot, updateSelectedBoatHouseData, clearCartData, getBoatHouseTimingData, getGst, getboatHouse, getBoatTypeList, handleBoatHouseChange, handleDateChange, boatTypeChange, getTimeSlot, getAvailableBoat, getOtherServices, AddOtherServicesCart, AddIndividualEnteranceCart, AddEnteranceCart, incrementEntranceCart, decrementEntranceCart, incrementOtherService, decrementOtherService, RemoveExpressBoat, RemoveTicket, RemoveBoat, RemoveEntrance, RemoveOtherservice, CheckLength, amountCalulation, loginUsers, checkloginData, ValidateEmail, RemoveExpressBookingSlot, RemoveTicketBookingSlot, RemoveBoatBookingSlot, BlockBookingTime, boatBooking, Boatclick, ContinueButton, removeboatdata, removeticketdata, removeExpressdata, ExpressTimeSlotClick, TicketTimeSlotClick, NormalTimeSlotClick } = this;
    return <DataContext.Provider value={{ SelectTimeSlot, HideTimeSlot, showUserInfo, showAmountInfo, handleLoginClose, handleOk, handleCancel, setOpenNotification, setFormApi, state, updateSelectedBoatHouseData, clearCartData, getBoatHouseTimingData, getGst, getboatHouse, getBoatTypeList, handleBoatHouseChange, handleDateChange, boatTypeChange, getTimeSlot, getAvailableBoat, getOtherServices, AddOtherServicesCart, AddIndividualEnteranceCart, AddEnteranceCart, incrementEntranceCart, decrementEntranceCart, incrementOtherService, decrementOtherService, RemoveExpressBoat, RemoveTicket, RemoveBoat, RemoveEntrance, RemoveOtherservice, CheckLength, amountCalulation, loginUsers, checkloginData, ValidateEmail, RemoveExpressBookingSlot, RemoveTicketBookingSlot, RemoveBoatBookingSlot, BlockBookingTime, boatBooking, Boatclick, ContinueButton, removeboatdata, removeticketdata, removeExpressdata, ExpressTimeSlotClick, TicketTimeSlotClick, NormalTimeSlotClick }}>{this.props.children}</DataContext.Provider>;
  }
}
